import { ObjectMapper } from "json-object-mapper";
import { RecruitmentVacancyPurpose } from "services/enums/RecruitmentVacancyPurpose.enum";
import { WorkforceplanEmployeeStatusType } from "services/enums/WorkforceplanEmployeeStatusType.enum";
import { WorkforceplanMovementType } from "services/enums/WorkforceplanMovementType.enum";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class WorkforcePlanTeamEmployeeModel extends Model implements IModel<WorkforcePlanTeamEmployeeModel> {
	id: string = "";
	name: string = "";
	jobTitleId: string = "";
	jobTitleName: string = "";
	jobTitleGroupId: string = "";
	jobTitleGroupName: string = "";
	status: string = WorkforceplanEmployeeStatusType.PENDING.label;
	shiftSchedule: string = "";
	registration: string = "";
	isPcd: boolean = false;
	cellPhoneNumber?: string = "";
	admissionDate?: string = "";
	profileImagePath?: string = "";
	companyId?: string = "";
	centerCostId?: string = "";
	timeShiftId?: string = "";
	timeShiftTitle?: string = "";
	costCenterName?: string = "";
	endFirstTrialPeriod?: string = "";
	endLastTrialPeriod?: string = "";
	workScaleGroup: string = "";
	tradeUnionId: string = "";
	tradeUnionName: string = "";
	movementRequestId: string = "";
	movementType: number | string | null = null;
	isApprentice: boolean = false;
	emergencyName?: string = "";
	emergencyKinship?: string = "";
	emergencyEmail?: string = "";
	emergencyContact?: string = "";
	increaseVacancyId: string = "";
	vacancyPurpose: number | string | null = null;

	get isPending(): boolean {
		return this.status === WorkforceplanEmployeeStatusType.PENDING.value;
	}

	get isHeadcountIncreasePending(): boolean {
		return (
			this.isPending &&
			(
				!!this.increaseVacancyId ||
				RecruitmentVacancyPurpose.isHeadcountIncrease(this.vacancyPurpose)
			)
		);
	}

	get pendingLabel(): string {
		if (!this.isPending) {
			return '';
		}
		return this.isHeadcountIncreasePending
			? RecruitmentVacancyPurpose.HeadcountIncrease.label
			: RecruitmentVacancyPurpose.Replacement.label;
	}

	get isInMovement(): boolean {
		return !!this.movementRequestId;
	}

	get movementTypeData(): WorkforceplanMovementType | undefined {
		return WorkforceplanMovementType.getByAny(this.movementType);
	}

	get isInternalTrainingMovement(): boolean {
		return this.movementTypeData === WorkforceplanMovementType.TRAINNING;
	}

	get isTrainingOrAptitudeMovement(): boolean {
		const type = this.movementTypeData;
		return (
			type === WorkforceplanMovementType.TRAINNING ||
			type === WorkforceplanMovementType.APTITUDE_TRAINNING
		);
	}

	get getStatusLabel(): string {
		return WorkforceplanEmployeeStatusType.getBy(this.status).label;
	}

	get statusBadge(): string {
		const status = WorkforceplanEmployeeStatusType.getBy(this.status);

		return `<span class="badge bg-${status?.className} text-wrap">${status?.label}</span>`;
	}

	static create(input: any): WorkforcePlanTeamEmployeeModel {
		return ObjectMapper.deserialize<WorkforcePlanTeamEmployeeModel>(
			WorkforcePlanTeamEmployeeModel,
			input
		);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}
}

export class WorkforcePlanTeamModel extends Model implements IModel<WorkforcePlanTeamModel> {
	amountVariance: { name: string, count: number }[] = [];
	workScaleGroup: string = "";
	headCount: string = "";
	employees: WorkforcePlanTeamEmployeeModel[] = [];

	static create(input: any): WorkforcePlanTeamModel {
		input.employees = input.employees.map((item) => WorkforcePlanTeamEmployeeModel.create(item));

		return ObjectMapper.deserialize<WorkforcePlanTeamModel>(
			WorkforcePlanTeamModel,
			input
		);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}
}
